function ForgotSection() {
    return(
        <>
            <div className="forgot-password-area pt-100 pb-70">
                <div className="container">
                    <div className="login-form">
                        <form className="my-account-content" onSubmit={(e)=>e.preventDefault()}>
                            <div className="section-title">
                                <h2>Forgot Password</h2>
                                <span className="top-title">Get Start With Us</span>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="email" className="form-control" placeholder="Email Address"/>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input minLength={8} required type="password" className="form-control" placeholder="Password"/>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit" className="default-btn btn-style-fore">Submit Now</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotSection